import ajax from '@/utils/ajax'
import urls from '@/utils/urls'
import md5 from 'md5'

export const login = async function (params) {
  // const userName = md5(params.account);
  // const password = md5(params.password);
  const {account: username, password} = params;
  return await ajax.Post(urls.login, {username, password});
};

export const contactUs = async function(params) {
  return await ajax.Post(urls.save, params);
};

export const getOpsList = async function (params) {
  return await ajax.Get(urls.getOpsList + `?opsName=${params.opsName}`);
}
